'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uiBtn = require('./ui-btn.less');

var _uiBtn2 = _interopRequireDefault(_uiBtn);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link;

var UiBtn = function (_Component) {
    _inherits(UiBtn, _Component);

    function UiBtn(props) {
        _classCallCheck(this, UiBtn);

        var _this = _possibleConstructorReturn(this, (UiBtn.__proto__ || Object.getPrototypeOf(UiBtn)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        _this.state = { isActive: false };
        Link = _this.props.routerLink ? _this.props.routerLink : null;

        _this.ref_button = _react2.default.createRef();
        return _this;
    }

    _createClass(UiBtn, [{
        key: 'render',
        value: function render() {
            return this.getBtnByElement();
        }
    }, {
        key: 'getBtnByElement',
        value: function getBtnByElement() {
            return !this.props.isDisabled && this.props.element === 'url' && this.props.url ? this.getHtmlBtnAsUrl() : this.getHtmlBtn();
        }
    }, {
        key: 'getHtmlBtn',
        value: function getHtmlBtn() {
            var cssButton = this.getCssButton();
            var htmlBtn = this.getBtnHTML();

            return _react2.default.createElement(
                'button',
                { ref: this.ref_button,
                    style: this.props.style ? this.props.style : {},
                    className: [cssButton, this.props.theme].join(" "),
                    onClick: this.onClick,
                    disabled: this.props.isDisabled,
                    type: this.props.type,
                    title: this.props.title,
                    tabIndex: this.props.tabIndex },
                htmlBtn,
                this.props.children
            );
        }
    }, {
        key: 'getHtmlBtnAsUrl',
        value: function getHtmlBtnAsUrl() {
            var _this2 = this;

            var cssButton = this.getCssButton();
            var htmlBtn = this.getBtnHTML();
            var isExternalUrl = /^((http|https):\/\/|\/\/)/.test(this.props.url);
            var urlTarget = isExternalUrl && this.props.target ? this.props.target : undefined;

            return isExternalUrl || !Link ? _react2.default.createElement(
                'a',
                { href: this.props.url, target: urlTarget, title: this.props.title, ref: this.ref_button, className: [cssButton, "ui-btn-element-url"].join(" "), onClick: this.onClick },
                _react2.default.createElement(
                    'span',
                    { className: "ui-btn__url-inner-wrapper" },
                    htmlBtn
                )
            ) : _react2.default.createElement(
                Link,
                { to: this.props.url, innerRef: function innerRef(ref) {
                        return _this2.ref_button.current = ref;
                    }, className: cssButton, onClick: this.onClick },
                _react2.default.createElement(
                    'span',
                    { className: "ui-btn__url-inner-wrapper" },
                    htmlBtn
                )
            );
        }
    }, {
        key: 'getBtnHTML',
        value: function getBtnHTML() {

            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.iconLeft && this.props.iconLeft.icon && _react2.default.createElement('span', { style: {
                        'textAlign': this.props.iconLeft.align ? this.props.iconLeft.align : 'left',
                        'width': this.props.iconLeft.width ? this.props.iconLeft.width : ''
                    },
                    className: ['ui-btn__icon-left', this.props.iconLeft.icon, this.getIconLeftState()].join(" ") }),
                this.props.iconLeft && this.props.iconLeft.iconToggle && _react2.default.createElement('span', { style: {
                        'textAlign': this.props.iconLeft.align ? this.props.iconLeft.align : 'left',
                        'width': this.props.iconLeft.width ? this.props.iconLeft.width : ''
                    },
                    className: ['ui-btn__icon-left', this.props.iconLeft.iconToggle ? this.props.iconLeft.iconToggle : '', this.getIconLeftToggleState()].join(" ") }),
                this.props.label && _react2.default.createElement(
                    'span',
                    { className: "ui-btn__label" },
                    this.props.label
                ),
                this.props.iconRight && this.props.iconRight.icon && _react2.default.createElement('span', { style: {
                        'textAlign': this.props.iconRight.align ? this.props.iconRight.align : 'right',
                        'width': this.props.iconRight.width ? this.props.iconRight.width : ''
                    },
                    className: ['ui-btn__icon-right', this.props.iconRight.icon, this.getIconRightState()].join(" ") }),
                this.props.iconRight && this.props.iconRight.iconToggle && _react2.default.createElement('span', { style: {
                        'textAlign': this.props.iconRight.align ? this.props.iconRight.align : 'right',
                        'width': this.props.iconRight.width ? this.props.iconRight.width : ''
                    },
                    className: ['ui-btn__icon-right', this.props.iconRight.iconToggle, this.getIconRightToggleState()].join(" ") })
            );
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {
            if (this.props.isDisabled) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                this.setState({ isActive: !this.state.isActive });

                if (this.props.onClick) {
                    this.props.onClick(event);
                }
            }

            return true;
        }
    }, {
        key: 'getCssButton',
        value: function getCssButton() {
            return ('ui-btn ' + this.getIsTruncating() + ' ' + this.getClassName()).trim();
        }
    }, {
        key: 'getIsTruncating',
        value: function getIsTruncating() {
            return this.props.isTruncating ? "ui-btn--truncate" : "";
        }
    }, {
        key: 'getIconLeftState',
        value: function getIconLeftState() {
            return this.state.isActive && this.props.iconLeft && this.props.iconLeft.iconToggle ? "ui-btn__icon-left--inactive" : "ui-btn__icon-left--active";
        }
    }, {
        key: 'getIconLeftToggleState',
        value: function getIconLeftToggleState() {
            return this.state.isActive && this.props.iconLeft && this.props.iconLeft.iconToggle ? "ui-btn__icon-left--active" : "ui-btn__icon-left--inactive";
        }
    }, {
        key: 'getIconRightState',
        value: function getIconRightState() {
            return this.state.isActive && this.props.iconRight.iconToggle ? "ui-btn__icon-right--inactive" : "ui-btn__icon-right--active";
        }
    }, {
        key: 'getIconRightToggleState',
        value: function getIconRightToggleState() {
            return this.state.isActive && this.props.iconRight.iconToggle ? "ui-btn__icon-right--active" : "ui-btn__icon-right--inactive";
        }
    }, {
        key: 'getClassName',
        value: function getClassName() {
            return this.props.className ? this.props.className : "";
        }
    }]);

    return UiBtn;
}(_react.Component);

UiBtn.propTypes = {
    onClick: _propTypes2.default.func,
    element: _propTypes2.default.oneOf(['button', 'url']),
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    url: _propTypes2.default.string,
    isTruncating: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    tabIndex: _propTypes2.default.number,
    routerLink: _propTypes2.default.any,
    target: _propTypes2.default.oneOf(['_self', '_blank']),
    type: _propTypes2.default.string,
    title: _propTypes2.default.string
};
UiBtn.defaultProps = {
    element: 'button',
    label: '',
    url: '', //Requires element prop to be set to url
    isTruncating: false, //If true, button truncates text such as "Click button to..."
    isDisabled: false,
    className: '',
    tabIndex: 0,
    routerLink: null,
    type: undefined,
    title: undefined
};
exports.default = UiBtn;